import * as autosize from "autosize";

export default angular.module("autoGrowDirective", [])
  .directive("autoGrow", [() => ({
    link(scope, element) {
      setTimeout(() => {
        autosize(element);
      }, 0);
    },
  })]);
